import Vue from "vue";
import { Store, Module, ActionContext } from "vuex";
import ListState from "./list-state";
import ActionTracking from "../entities/actionTracking";
import ActionCheckpoint from "../entities/actionCheckpoint";
import Ajax from "../../lib/ajax";
import ListMutations from "./list-mutations";
import Goal from "../entities/goal";
import Project from "../entities/project";
import Objective from "../entities/objective";
import BioCalculator from "../../lib/bioCalculator";
import moment from "moment";
import Cookies from "js-cookie";

let _: any = require("lodash");

const LAST_SELECTED_GOAL_ID_KEY: string = "lastSelectedGoalId";
const LAST_SELECTED_MEMBER_ID_KEY: string = "lastSelectedMemberId";
const TARGET_USER_FILTER_KEY: string = "targetUserFilter";
const ASSESSMENT_FILTER_KEY: string = "assessmentFilter";
const DATE_FILTER_KEY: string = "dateFilter";
const cookieExpires: number = 1;

let getLastSelectedGoalIdFromCookie = function(): string {
  return Cookies.get(LAST_SELECTED_GOAL_ID_KEY);
};

let getLastSelectedMemberIdFromCookie = function(): number {
  let value: string = Cookies.get(LAST_SELECTED_MEMBER_ID_KEY);

  return value ? Number(value) : NaN;
};

let getAssessmentFilterFromCookie = function(): string {
  //return Cookies.get(ASSESSMENT_FILTER_KEY);
  return "both";
};

let getTargetUserFilterFromCookie = function(): number {
  //let value: string = Cookies.get(TARGET_USER_FILTER_KEY);
  //return value ? Number(value) : NaN;

  return 0; // 0: All Team
};

let getDateFilterFromCookie = function(): Date {
  //let value: string = Cookies.get(DATE_FILTER_KEY);
  //return value ? new Date(value) : null;

  var endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  return endOfToday;
};

let getExclusionFromCookie = function(): string {
  //return Cookies.get(Exclusion_KEY);
  return "none";
};

// tslint:disable-next-line: interface-name
interface GoalState {
  loading: boolean;
  lastSelectedGoalId: string;
  lastSelectedMemberId: number;
  targetUserFilter: number;
  assessmentFilter: string;
  dateFilter: Date;
  goals: Goal[];
  goalsExclusion: string;
  myTrackingGoals: Goal[];
  editableGoals: Goal[];
  myGoals: Goal[];
  myObjectives: Objective[];
  currentGoal: Goal;
  currentGoalLoadingCount: number;
  currentGoalHasCheckpointUpdated: boolean;
  currentGoalMemberMap: Map<number, string>;
  currentGoalMembers: {
    id: number;
    name: string;
    role: number;
    roleName: string;
  }[];
  currentGoalTrackingMembers: {
    id: number;
    name: string;
    role: number;
    roleName: string;
  }[];
  currentObjective: Objective;
  currentProject: Project;
  currentActionTrackingInformation: ActionTracking;
  currentCheckpoint: ActionCheckpoint;
  dailyQuickTrackingInformations: any;
  incompletedCheckpoints: any[];
  completedCheckpoints: any[];
}
class BioMutations extends ListMutations<Goal> {}

var endOfToday = new Date();
endOfToday.setHours(23, 59, 59, 999);

export const state: GoalState = {
  loading: false,
  lastSelectedGoalId: getLastSelectedGoalIdFromCookie() || null,
  lastSelectedMemberId: getLastSelectedMemberIdFromCookie() || null,
  targetUserFilter: getTargetUserFilterFromCookie() || 0,
  assessmentFilter: getAssessmentFilterFromCookie() || "self",
  dateFilter: getDateFilterFromCookie() || endOfToday,
  goals: new Array<Goal>(),
  goalsExclusion: "none",
  myTrackingGoals: new Array<Goal>(),
  editableGoals: new Array<Goal>(),
  myGoals: new Array<Goal>(),
  myObjectives: new Array<Objective>(),
  currentGoal: new Goal(),
  currentGoalLoadingCount: 0,
  currentGoalHasCheckpointUpdated: false,
  currentGoalMemberMap: new Map<number, string>(),
  currentGoalMembers: [],
  currentGoalTrackingMembers: [],
  currentObjective: new Objective(),
  currentProject: new Project(),
  currentActionTrackingInformation: new ActionTracking(),
  currentCheckpoint: null,
  dailyQuickTrackingInformations: null,
  incompletedCheckpoints: [],
  completedCheckpoints: []
};

const goalModule: Module<GoalState, any> = {
  namespaced: true,
  state,
  getters: {
    permissionOptions: state => {
      return [
        {
          value: 1,
          label: "Admin",
          description: "Can add and edit all bio details, goals, objectives, projects, and member (regardless of bio role).",
          disabled: false
        },
        {
          value: 0,
          label: "Normal",
          description: "Can view all team goals, objectives, and members. Can be assigned actions and accountabilities.",
          disabled: false
        }
      ];
    },
    calculationOptions: state => {
      return [
        {
          value: 1,
          label: "Last Check-in Result Only",
          description: "Display the last check-in result only when reporting target progress",
          disabled: false
        },
        {
          value: 2,
          label: "Average All Check-in Results",
          description: "Display the average of all check-in results when reporting target progress",
          disabled: false
        }
      ];
    },
    keyResultTypeOptions: state => {
      return [
        {
          value: 2,
          label: "$ Dollar Amount",
          description: "Is a target to hit a single dollar amount i.e. revenue, profit, income, savings, reduce cost, etc.",
          disabled: false
        },
        {
          value: 1,
          label: "# Number",
          description: "Is a target to hit a single number i.e. # of sales calls completed, # of gym visits, etc.",
          disabled: false
        },
        {
          value: 3,
          label: "% Percentage Point",
          description: "Is a target to hit a single percentage point i.e. % of revenue growth, % of service tickets closed, % score on test, etc.",
          disabled: false
        },
        {
          value: 4,
          label: "Grading Scale",
          description: "Is a target on a grading scale i.e. scale 1 to 4, pass or fail, yes or no, etc.",
          disabled: false
        }
      ];
    },
    memberRoleTitle: state => {
      return "Contributor";
    },
    authorRoleTitle: state => {
      return "Author";
    },
    authorAndMemberRoleTitle: state => {
      return "Author & Contributor";
    },
    roleTitle: (state, getters) => role => {
      if (role === 3) {
        return getters.memberRoleTitle;
      } else if (role === 4) {
        return "Fan";
      } else if (role === 5) {
        return getters.authorRoleTitle;
      } else if (role === 6) {
        return getters.authorAndMemberRoleTitle;
      } else {
        return "Unknown";
      }
    },
    currentGoalGrades: state => {
      let grades = state.currentGoal && state.currentGoal.gradeModel ? JSON.parse(state.currentGoal.gradeModel) : [];

      return grades.sort(function(a: any, b: any): number {
        return a.from - b.from;
      });
    },
    canAdd: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;
      if (billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          return member.grantedPermissions.includes("Bio.AddBio");
        }
      }

      return false;
    },
    canEdit: state => goal => {
      return goal && goal.grantedPermissions && goal.grantedPermissions.includes("Bio.EditBio");
    },
    canEditCurrentGoal: state => {
      return state.currentGoal && state.currentGoal.grantedPermissions && state.currentGoal.grantedPermissions.includes("Bio.EditBio");
    },
    canInviteMemberInCurrentGoal: (state, getters, rootState) => {
      let billingAccount = rootState.billing.billingAccount;
      let user = rootState.session.user;

      if (state.currentGoal && state.currentGoal.grantedPermissions && billingAccount && user) {
        let members = billingAccount.members.filter(m => m.memberId == user.id);
        if (members.length === 1) {
          let member = members[0];

          let permissions = state.currentGoal.grantedPermissions.concat(member.grantedPermissions);
          return permissions.includes("Bio.AssignAuthorRole") || permissions.includes("Bio.AssignMember") || permissions.includes("Bio.AssignFan");
        }
      }

      return false;
    },
    getRoleDetails: (state, getters, rootState) => role => {
      if (role === 3) {
        return {
          value: 3,
          name: "member",
          title: "Contributor only",
          description: "Contributor only is accountable to chart target check-in result. Not able to add, edit, and delete target information."
        };
      } else if (role === 4) {
        return {
          value: 4,
          name: "fan",
          title: "Fan only",
          description: 'Fan only can "see-only" all target information. Not able to add, edit, and delete target information. Not accountable to chart target check-in result.'
        };
      } else if (role === 5) {
        return {
          value: 5,
          name: "author",
          title: "Author only",
          description: "Author only can add, edit, and delete target information. Not accountable to chart target check-in results."
        };
      } else if (role === 6) {
        return {
          value: 6,
          name: "authorAndMember",
          title: "Author & Contributor",
          description: "Both author & contributor. Author can add, edit, and delete target information. Contributor is accountable to chart target check-in results."
        };
      } else {
        return null;
      }
    },
    currentGoalInviteRoles: (state, getters, rootState) => (memberId, goal) => {
      let billingAccount = rootState.billing.billingAccount;
      if (!goal) {
        goal = state.currentGoal;
      }

      let results = [];
      if (goal && goal.grantedPermissions && billingAccount) {
        let members = billingAccount.members.filter(m => m.memberId == memberId);
        if (members.length === 1) {
          let member = members[0];

          results.push(
            Object.assign(
              {
                disabled: !(goal.grantedPermissions.includes("Bio.AssignAuthorRole") && member.grantedPermissions.includes("Bio.BeAuthor"))
              },
              getters.getRoleDetails(6)
            )
          );

          results.push(
            Object.assign(
              {
                disabled: !(goal.grantedPermissions.includes("Bio.AssignAuthorRole") && member.grantedPermissions.includes("Bio.BeAuthor"))
              },
              getters.getRoleDetails(5)
            )
          );

          results.push(
            Object.assign(
              {
                disabled: !(goal.grantedPermissions.includes("Bio.AssignMember") && member.grantedPermissions.includes("Bio.BeMember"))
              },
              getters.getRoleDetails(3)
            )
          );

          results.push(
            Object.assign(
              {
                disabled: !(goal.grantedPermissions.includes("Bio.AssignFan") && member.grantedPermissions.includes("Bio.BeFan"))
              },
              getters.getRoleDetails(4)
            )
          );
        }
      }

      return results;
    }
  },
  actions: {
    async getMyGoals(context: any, payload: any) {
      context.state.loading = true;
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      await Ajax.get(`/api/services/app/Goal/GetMyGoals?billingAccountId=${billingAccountId}&exclusion=`).then(response => {
        let goals = response.data.result.myGoals;
        goals.forEach(goal => {
          goal.hashTagList = goal.hashTags ? JSON.parse(goal.hashTags) : [];
        });
        context.state.goals = goals;
        context.state.myGoals = goals;
        context.state.myObjectives = response.data.result.myObjectives;
      });
      context.state.loading = false;
    },
    async getEditableGoals(context: any, payload: any) {
      await Ajax.get("/api/services/app/Goal/GetEditableGoals").then(response => {
        context.state.editableGoals = response.data.result;
      });
    },
    async getMyTrackingGoals(context: any, payload: any) {
      context.state.loading = true;
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      await Ajax.get(`/api/services/app/Goal/GetMyTrackingGoals?billingAccountId=${billingAccountId}`)
        .then(response => {
          let goals = response.data.result;
          goals.forEach(goal => {
            goal.hashTagList = goal.hashTags ? JSON.parse(goal.hashTags) : [];
          });
          context.state.myTrackingGoals = goals;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    create(context: ActionContext<GoalState, any>, payload: any) {
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      payload.data.billingAccountId = billingAccountId;
      return Ajax.post("/api/services/app/Goal/Create", payload.data).then(response => {
        context.dispatch("getMyGoals", {});
      });
    },
    update(context: ActionContext<GoalState, any>, payload: any) {
      return Ajax.put("/api/services/app/Goal/Update", payload.data).then(response => {
        if (context.state.currentGoal && context.state.currentGoal.id === payload.data.id) {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        }

        context.dispatch("getMyGoals", {});
      });
    },
    copy(context: ActionContext<GoalState, any>, payload: any) {
      let billingAccountId = window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0;
      payload.data.billingAccountId = billingAccountId;
      Ajax.post("/api/services/app/Goal/Copy", payload.data).then(response => {
        context.dispatch("getMyGoals", {});
      });
    },
    delete(context: ActionContext<GoalState, any>, payload: any) {
      Ajax.delete("/api/services/app/Goal/Delete?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyGoals", {});
      });
    },
    async undelete(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.post("/api/services/app/Goal/Undelete?Id=" + payload.data.id);
      context.state.loading = false;
    },
    async unarchive(context: ActionContext<GoalState, any>, payload: any) {
      Ajax.post("/api/services/app/Goal/Unarchive?Id=" + payload.data.id).then(response => {
        context.dispatch("getMyGoals", {});
      });
    },
    async get(context: any, payload: any) {
      context.state.loading = true;
      await Ajax.get("/api/services/app/Goal/Get?Id=" + payload.id).then(response => {
        let goal = response.data.result as Goal;
        loadGoal(context, goal);
      });
      context.state.loading = false;

      return context.state.currentGoal;
    },
    async acceptInvitation(context: ActionContext<GoalState, any>, payload: any) {
      let result = null;

      await Ajax.post("/api/services/app/Goal/AcceptInvitation", payload).then(response => {
        result = response;
      });

      return result;
    },
    async inviteMember(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Goal/InviteMember", payload.data)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async updateMember(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.put("/api/services/app/Goal/UpdateMember", payload.data)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async removeMember(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      let queryString = Object.keys(payload.data)
        .map(key => {
          return encodeURIComponent(key) + "=" + encodeURIComponent(payload.data[key]);
        })
        .join("&");
      return Ajax.delete(`/api/services/app/Goal/RemoveMember?${queryString}`)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async upsertTeam(context: ActionContext<GoalState, any>, payload: any) {
      return Ajax.post("/api/services/app/Goal/UpsertTeam", payload.data);
    },
    async removeTeam(context: ActionContext<GoalState, any>, payload: any) {
      let queryString = Object.keys(payload.data)
        .map(key => {
          return encodeURIComponent(key) + "=" + encodeURIComponent(payload.data[key]);
        })
        .join("&");
      return Ajax.delete(`/api/services/app/Goal/RemoveTeam?${queryString}`);
    },
    async createObjective(context: ActionContext<GoalState, any>, payload: any) {
      await Ajax.post("/api/services/app/Objective/Create", payload.data);
    },
    async getObjective(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.get("/api/services/app/Objective/Get?Id=" + payload.id).then(response => {
        context.state.currentObjective = response.data.result as Objective;
      });
      context.state.loading = false;

      return context.state.currentObjective;
    },
    async upsertObjective(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Goal/UpsertObjective", payload.data)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async updateCheckpoint(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.put("/api/services/app/Goal/UpdateCheckpoint", payload.data)
        .then(response => {
          //let goal = response.data.result as Goal;
          //loadGoal(context, goal);

          context.state.currentGoalHasCheckpointUpdated = true;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async copyObjective(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Goal/CopyObjective", payload.data)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async deleteObjective(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.delete(`/api/services/app/Goal/DeleteObjective?GoalId=${payload.data.goalId}&Id=${payload.data.id}`)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async undeleteObjective(context: ActionContext<GoalState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post(`/api/services/app/Goal/UndeleteObjective?GoalId=${payload.data.goalId}&Id=${payload.data.id}`)
        .then(response => {
          let goal = response.data.result as Goal;
          loadGoal(context, goal);
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    setLastSelectedGoalId(context: ActionContext<GoalState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_GOAL_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedGoalId = newValue;
    },
    setLastSelectedMemberId(context: ActionContext<GoalState, any>, newValue: string) {
      Cookies.set(LAST_SELECTED_MEMBER_ID_KEY, newValue, { expires: cookieExpires });
      context.state.lastSelectedMemberId = Number(newValue);
    },
    setTargetUserFilter(context: ActionContext<GoalState, any>, newValue: string) {
      Cookies.set(TARGET_USER_FILTER_KEY, newValue, { expires: cookieExpires });
      context.state.targetUserFilter = Number(newValue);
      context.dispatch("recalculateTrackingResults");
    },
    setAssessmentFilter(context: ActionContext<GoalState, any>, newValue: string) {
      Cookies.set(ASSESSMENT_FILTER_KEY, newValue, { expires: cookieExpires });
      context.state.assessmentFilter = newValue;
      context.dispatch("recalculateTrackingResults");
    },
    setDateFilter(context: ActionContext<GoalState, any>, newValue: Date) {
      Cookies.set(DATE_FILTER_KEY, newValue.toString(), { expires: cookieExpires });
      context.state.dateFilter = newValue;
      context.dispatch("recalculateTrackingResults");
    },
    setGoalExclusionFilter(context: ActionContext<GoalState, any>, newValue: string) {
      context.state.goalsExclusion = newValue;
    },
    recalculateTrackingResults(context: ActionContext<GoalState, any>) {
      Cookies.set(ASSESSMENT_FILTER_KEY, "both", { expires: cookieExpires });
      context.state.assessmentFilter = "both";
      let exclusion = context.state.currentGoal.calculationOption === 1 ? "lastCheckin" : "none";
      BioCalculator.calculateGoal(context.state.currentGoal, context.state.targetUserFilter, context.state.assessmentFilter, context.state.dateFilter, exclusion);
    },
    async changeMyRoleList(context: ActionContext<GoalState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyRoleList", payload).then(response => {
        result = response;
      });

      return result;
    },
    async changeMyGradeList(context: ActionContext<GoalState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyGradeList", payload).then(response => {
        result = response;
      });

      return result;
    },
    async changeMyTargetScaleList(context: ActionContext<GoalState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyTargetScaleList", payload).then(response => {
        result = response;
      });

      return result;
    },
    async changeMyUnitList(context: ActionContext<GoalState, any>, payload: any) {
      let result = null;
      await Ajax.post("/api/services/app/Configuration/ChangeMyUnitList", payload).then(response => {
        result = response;
      });

      return result;
    }
  }
};

function loadGoal(context: ActionContext<GoalState, any>, goal: Goal) {
  goal.objectives = goal.content ? JSON.parse(goal.content).objectives : [];

  context.state.currentGoal = goal;
  context.state.currentGoalLoadingCount += 1;
  context.state.currentGoalHasCheckpointUpdated = false;

  let memberMap = new Map(goal.members.map((member): [number, string] => [member.memberId, member.memberName]));
  let checkpoints = [];
  if (goal && goal.objectives) {
    goal.objectives.forEach(objective => {
      if (objective && objective.checkpoints) {
        checkpoints = checkpoints.concat(
          objective.checkpoints.map(checkpoint => {
            checkpoint.targetUserName = memberMap.get(checkpoint.targetUserId);
            checkpoint.trackerName = memberMap.get(checkpoint.trackerId);
            return {
              dateString: moment(checkpoint.trackingDate).format("YYYY-MM-DD"),
              path: `${goal.name} ${objective.name}`,
              goal: goal.name,
              objective: objective.name,
              priority: objective.priority,
              objectivePriority: objective.priority,
              data: {
                role: "",
                goalName: goal.name,
                objectiveName: objective.name,
                goalId: goal.id,
                objectiveId: objective.id,
                id: objective.id,
                priority: objective.priority,
                targetType: objective.targetType,
                measurementUnit: objective.measurementUnit,
                inputOptions: objective.inputOptions,
                trackingTarget: objective.trackingTarget,
                trackingQuestion: objective.trackingQuestion,
                attachments: objective.attachments,
                checkpoint: checkpoint
              }
            };
          })
        );
      }
    });
  }

  context.state.incompletedCheckpoints = checkpoints.filter(cp => cp.data.checkpoint.value === null || cp.data.checkpoint.value === "");
  context.state.completedCheckpoints = checkpoints.filter(cp => cp.data.checkpoint.value !== null && cp.data.checkpoint.value !== "");

  Cookies.set(ASSESSMENT_FILTER_KEY, "both", { expires: cookieExpires });
  context.state.assessmentFilter = "both";

  context.state.currentGoalMembers = goal.members
    .filter(member => member.role !== 4)
    .map(member => {
      let roleName = member.role === 6 ? "Author & Contributor" : "Contributor";
      return {
        id: member.memberId,
        name: `${member.memberName} - ${roleName}`,
        role: member.role,
        roleName: roleName
      };
    });

  context.state.currentGoalTrackingMembers = context.state.currentGoalMembers.filter(member => member.role === 3 || member.role === 6);

  let trackerFilterChanged = false;
  let lastFilterTracker = context.state.currentGoalTrackingMembers.filter(member => member.id === context.state.targetUserFilter);
  if (lastFilterTracker.length === 0) {
    let newFilterValue = context.state.currentGoalTrackingMembers.length === 1 ? context.state.currentGoalTrackingMembers[0].id : "0";
    if (newFilterValue !== context.state.targetUserFilter) {
      context.dispatch("setTargetUserFilter", newFilterValue);
      trackerFilterChanged = true;
    }
  }

  if (!trackerFilterChanged) {
    let exclusion = goal.calculationOption === 1 ? "lastCheckin" : "none";
    BioCalculator.calculateGoal(goal, context.state.targetUserFilter, context.state.assessmentFilter, context.state.dateFilter, exclusion);
  }
}

export default goalModule;
